/* ==========================================================================
   SleepBand - przelacznik "Zabezpieczona przesylka" w szufladzie koszyka.

   Nasluch jest delegowany na dokument, bo motyw podmienia cala zawartosc
   .drawer__inner przy kazdej aktualizacji koszyka.
   ========================================================================== */
(function () {
  'use strict';

  function refreshDrawer() {
    var items = document.querySelector('cart-drawer-items');
    if (items && typeof items.updateCart === 'function') {
      items.updateCart();
    } else {
      window.location.reload();
    }
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json();
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('.lumicart__switch');
    if (!toggle) return;

    var box = toggle.closest('[data-lumi-protection]');
    if (!box || box.classList.contains('is-loading')) return;

    event.preventDefault();

    var isOn = box.dataset.active === 'true';
    var request = isOn
      ? post('/cart/change.js', { line: parseInt(box.dataset.line, 10), quantity: 0 })
      : post('/cart/add.js', { items: [{ id: parseInt(box.dataset.variant, 10), quantity: 1 }] });

    box.classList.add('is-loading');
    // optymistyczny stan przelacznika, zanim koszyk sie przerysuje
    box.classList.toggle('is-on', !isOn);
    toggle.setAttribute('aria-checked', String(!isOn));

    request
      .then(refreshDrawer)
      .catch(function (error) {
        console.error(error);
        box.classList.toggle('is-on', isOn);
        toggle.setAttribute('aria-checked', String(isOn));
      })
      .finally(function () {
        box.classList.remove('is-loading');
      });
  });
})();
